import { collection, onSnapshot, query, where } from "firebase/firestore"

import { db } from "../../firebaseFirestore"

export type LiveDrawingInfo = {
  id: string
  name?: string
}

export const watchLiveDrawings = (
  cb: (drawings: LiveDrawingInfo[]) => void,
): (() => void) => {
  const q = query(collection(db, "raffles"), where("isDrawingLive", "==", true))
  return onSnapshot(q, (snap) => {
    const drawings: LiveDrawingInfo[] = []
    snap.forEach((d) => {
      const data = d.data()
      drawings.push({ id: d.id, name: data?.name || data?.title || undefined })
    })
    cb(drawings)
  })
}
